export enum Permission {
  ViewUserManagement = 'ViewUserManagement',
  ManageUsers = 'ManageUsers',
  ViewGroups = 'ViewGroups',
  ManageGroups = 'ManageGroups',
  ViewProducts = 'ViewProducts',
  ManageProducts = 'ManageProducts',
  ViewMemberships = 'ViewMemberships',
  ManageMemberships = 'ManageMemberships',
  ViewCategories = 'ViewCategories',
  ManageCategories = 'ManageCategories',
  AccessLearnerArea = 'AccessLearnerArea',
  Reports = 'Reports',
}

import { ERole } from './roles';

export const PERMISSIONS_BY_ROLE: Record<ERole, ReadonlySet<Permission>> = {
  [ERole.SuperAdmin]: new Set([
    Permission.ViewUserManagement,
    Permission.ManageUsers,
    Permission.ViewGroups,
    Permission.ManageGroups,
    Permission.ViewProducts,
    Permission.ManageProducts,
    Permission.ViewMemberships,
    Permission.ManageMemberships,
    Permission.ViewCategories,
    Permission.ManageCategories,
    Permission.AccessLearnerArea,
    Permission.Reports,
  ]),

  [ERole.SupportAdmin]: new Set([
    Permission.ViewUserManagement,
    Permission.ManageUsers,
    Permission.ViewGroups,
    Permission.ManageGroups,
    Permission.AccessLearnerArea,
    Permission.Reports,
  ]),

  [ERole.GroupAdmin]: new Set([
    Permission.ViewUserManagement,
    Permission.ViewGroups,
    Permission.AccessLearnerArea,
    Permission.Reports,
  ]),

  // Sub-Group Admin is a sub-group-scoped admin with report access (mirrors GroupAdmin;
  // data boundaries are enforced server-side). "Org admin" is a GroupAdmin whose group is an
  // Organization — same permissions, no separate role.
  [ERole.SubGroupAdmin]: new Set([
    Permission.ViewUserManagement,
    Permission.ViewGroups,
    Permission.AccessLearnerArea,
    Permission.Reports,
  ]),

  [ERole.Learner]: new Set([Permission.AccessLearnerArea]),
};
